import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchClients, // Unified function: accepts (page, filters, all)
fetchClient, // Fetch a single client
addClient, updateClient, deleteClient, } from "@/features/client/services/clientService";
const useClients = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    // The query function now passes page, filters, and all to fetchClients.
    const { data, error, isLoading, refetch } = useQuery(["clients", { page, filters, all, limit }], () => fetchClients(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 60000, // Data is fresh for 60 seconds.
    });
    // Mutation for adding a new client.
    const addClientMutation = useMutation((client) => addClient(client), {
        onSuccess: () => {
            queryClient.invalidateQueries(["clients"]);
        },
    });
    // Mutation for updating an existing client.
    const updateClientMutation = useMutation(({ id, clientData }) => updateClient(id, clientData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["clients"]);
        },
    });
    // Mutation for deleting a client.
    const deleteClientMutation = useMutation((id) => deleteClient(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(["clients"]);
        },
    });
    // Helper to fetch a single client.
    const fetchSingleClient = async (id) => {
        return await fetchClient(id);
    };
    return {
        clients: data?.clients || [],
        meta: data?.meta || null,
        loading: isLoading,
        error: error ? error.message : null,
        refetchClients: refetch,
        handleAddClient: addClientMutation.mutateAsync,
        handleUpdateClient: (id, clientData) => updateClientMutation.mutateAsync({ id, clientData }),
        handleDeleteClient: deleteClientMutation.mutateAsync,
        fetchClient: fetchSingleClient,
    };
};
export default useClients;
